document.addEventListener("DOMContentLoaded", () => {
  const tabButtons = document.querySelectorAll(".tabs-one__tab");
  const tabContents = document.querySelectorAll(".tabs-one__info");

  if (!tabButtons.length || !tabContents.length) return;

  tabButtons.forEach((tab, index) => {
    tab.addEventListener("click", () => {
      tabButtons.forEach((btn) => btn.classList.remove("isActive"));
      tabContents.forEach((content) => content.classList.remove("isActive"));

      tab.classList.add("isActive");
      tabContents[index].classList.add("isActive");
    });
  });
});
